module.exports = __webpack_public_path__ + "img/houzheng.b4039c6d.jpg";